import script from "./AdministratorProjectReport.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectReport.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectReport.vue?vue&type=style&index=0&id=740c304c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740c304c"]])

export default __exports__